export enum Chart {
	BLOOD_PRESSURE = 'blood_pressure',
	BLOOD_PRESSURE_SYS_DIA = 'blood_pressure_sys_dia',
	WEIGHT = 'weight',
	HEIGHT = 'height',
	WAISTLINE = 'waistline',
	BLOOD_GLUCOSE = 'blood_glucose',
	STEPS = 'step_count',
	BREATHING_RATE = 'breathing_rate',
	OXYGEN_SATURATION = 'oxygen_saturation',
	SLEEP = 'sleep',
	HEMOGLOBIN = 'hemoglobin',
	HEMOGLOBIN_A1C = 'hemoglobinA1C',
	STRESS_LEVEL = 'stress_level',
	ACTIVE_ENERGY = 'active_energy',
	DISTANCE_WALKING_RUNNING = 'distance_walking_running',
	WORKOUT = 'workout',
	ACTUAL_WEIGHT = 'actualWeight',
	CTG = 'ctg',
	DIASTOLIC_BLOOD_PRESSURE = 'diastolicBloodPressure',
	SYSTOLIC_BLOOD_PRESSURE = 'systolicBloodPressure',
	TOTAL_NUMBER_OF_PREGNANCIES = 'totalNumberOfPregnancies',
	WEIGHT_BEFORE_PREGNANCY = 'weightBeforePregnancy',
	ADDITIONAL_WEIGHT = 'additionalWeight',
	EDEMAS = 'edemas',
	BODY_TEMPERATURE = 'bodyTemperature',
	URINE_PROTEIN = 'urineProtein',
	URINE_GLUCOSE = 'urineGlucose',
	URINE_BLOOD = 'urineBlood',
	ESAS = 'esas',
}
